export const GET_STATEMENTS = "GET_STATEMENTS";
export const GET_STATEMENT_BY_ID = "GET_STATEMENT_BY_ID";
export const UPDATE_STATEMENT = "UPDATE_STATEMENT";
export const DELETE_STATEMENT = "DELETE_STATEMENT";
export const CREATE_STATEMENT = "CREATE_STATEMENT";
export const GENERATE_INVOICE = "GENERATE_INVOICE";
